const configDeploy = require(`${__dirname}/env/config.deploy.json`);
const configUrlSlugs = require(`${__dirname}/env/config.url_slugs.json`);

const getUrlSlugByDomainBuildCode = domainBuildCode => {
  // Check if environment variable is empty or not set
  if (!domainBuildCode) {
    console.error("❌ Error: Domain build code is not set or is empty");
    return "";
  }

  // Skip processing for home environments
  if (domainBuildCode.includes("home")) {
    return "";
  }

  false &&
    console.log(
      `\n🚀 Starting URL slug resolution for domain: ${domainBuildCode}`
    );

  // Handle both legacy and new format domains
  const themePart = domainBuildCode.includes("_")
    ? domainBuildCode.split("_")[1] // New format: "555travel_africa006" -> "africa006"
    : domainBuildCode; // Legacy format: "africa006" -> "africa006"

  false && console.log(`🔧 Theme part extracted: ${themePart}`);

  if (!themePart) {
    console.error(`❌ Error: Invalid format in ${domainBuildCode}`);
    throw new Error(`Invalid domain build code format: ${domainBuildCode}`);
  }

  if (themePart.length < 3) {
    console.error(`❌ Error: Theme part too short: ${themePart}`);
    throw new Error(`Theme part should end with 3 digits: ${domainBuildCode}`);
  }

  // Find where the number starts (last 3 characters)
  const themeLength = themePart.length - 3;
  const theme = themePart.slice(0, themeLength); // e.g., "africa"
  const number = parseInt(themePart.slice(themeLength), 10); // e.g., "006" -> 6
  false && console.log(`🎯 Extracted theme: "${theme}", number: ${number}`);

  // Get the array of slug variations for this theme
  const slugVariations = configUrlSlugs.themeToSlugVariations[theme];
  false && console.log(`🔍 Looking for slug variations for theme "${theme}"`);

  if (!slugVariations) {
    console.error(`❌ Error: Theme "${theme}" not found in configuration`);
    throw new Error(
      `Theme "${theme}" not found in configUrlSlugs.themeToSlugVariations`
    );
  }

  false &&
    console.log(
      `📋 Found ${slugVariations.length} variations for theme "${theme}"`
    );

  // The number (minus 1) is the index in the array
  // We subtract 1 because domain numbers start at 1 but array indices start at 0
  const slugIndex = number; // - 1;
  false &&
    console.log(`🔢 Calculating slug index: ${number} - 1 = ${slugIndex}`);

  if (slugIndex < 0 || slugIndex >= slugVariations.length) {
    console.error(
      `❌ Error: Index ${slugIndex} out of bounds for theme "${theme}"`
    );
    throw new Error(
      `Invalid number ${number} for theme "${theme}". Available variations: ${slugVariations.length}`
    );
  }

  const result = slugVariations[slugIndex];
  false && console.log(`✨ Found URL slug: ${result}`);
  false && console.log(`✅ URL slug resolution completed successfully!\n`);

  return result;
};

module.exports = {
  getUrlSlugByDomainBuildCode,
};
